import { render } from "./add_new_product.vue?vue&type=template&id=60ceb816&scoped=true"
import script from "./add_new_product.vue?vue&type=script&lang=js"
export * from "./add_new_product.vue?vue&type=script&lang=js"

import "./add_new_product.vue?vue&type=style&index=0&id=60ceb816&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ceb816"]])

export default __exports__